import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaIterableNode } from './TypedNode'
import { SchemaIterableModel } from './ViewModel'

export const SchemaIterablePlugin = createSchemaPlugin(
  'Schema.Iterable',
  SchemaIterableModel,
  SchemaIterableNode
)
